import { Component, Input } from '@angular/core';

/**
 * CARGA DE PANTALLA con cuadros grises (kb-skeleton) que simulan el contenido: tarjetas de cifras arriba, y debajo una barra, un gráfico y bloques
 * (tarjeta con encabezado y filas). Misma rejilla y tamaños que lo real, para que nada salte al llegar los datos. Solo para la carga inicial de una
 * pantalla; los textos de acciones en curso («Generando…») y los errores no pasan por aquí. Uso: `<app-cargando-cuadros *ngIf="cargando && !r" [tarjetas]="4" [filas]="5">`.
 */
@Component({
  selector: 'app-cargando-cuadros',
  templateUrl: './cargando-cuadros.component.html'
})
export class CargandoCuadrosComponent {
  /** Cuántas tarjetas de cifras (en una rejilla de hasta 4 por fila). */
  @Input() tarjetas = 0;
  /** Cuántas filas grises lleva cada bloque. */
  @Input() filas = 0;
  /** Cuántos bloques (tarjeta con encabezado y filas) se dibujan; solo si hay filas. */
  @Input() bloques = 1;
  /** Una barra de proporción (como «A dónde fue lo recibido»). */
  @Input() barra = false;
  /** Un gráfico de 280 px de alto. */
  @Input() grafico = false;
  /** Con false, solo las filas, sin tarjeta alrededor (para ponerlo dentro de una tarjeta que ya existe). */
  @Input() envuelto = true;

  seq = (n: number): number[] => Array.from({ length: Math.max(0, Math.floor(Number(n) || 0)) }, (_, i) => i);
}
